<div class="chart-donut">
  <apx-chart #chart [chart]="chartData" [title]="chartTitle" [colors]="colorsData" [legend]="legendData"
    [labels]="label" [series]="seriesData" [responsive]="responsiveData" [plotOptions]="plotOptions"
    [dataLabels]="dataLabels" [stroke]="stroke"></apx-chart>
</div>